"use strict";

exports.__esModule = true;
exports.camelToKebab = camelToKebab;
function camelToKebab(str) {
  return str.split(/(?=[A-Z])/).join('-').toLowerCase();
}
//# sourceMappingURL=utils.js.map